module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_4750_Active@1x-8d86e705b48f62fd3e436ef4343078b6.png";